import { PMBMonthPicker } from 'components/PMBNewDatePicker'
import { useState } from 'react'
import CustomButton from 'components/Buttons/CustomButton'
import { ChevronUp, Layers, RefreshCw } from 'react-feather'
import { Spinner } from 'reactstrap'
import { ESG_METRICS, ESG_MODES, LAYERS } from './layers'

const Segment = ({ label, options, value, onChange }) => (
  <div className="gm-segment" role="radiogroup" aria-label={label}>
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        role="radio"
        aria-checked={value === o.value}
        className={value === o.value ? 'gm-segment--active' : ''}
        onClick={() => onChange(o.value)}
      >
        {o.label}
      </button>
    ))}
  </div>
)

export default function LayerPanel({
  layers,
  onChange,
  disabledReason,
  status,
  parcelsProgress,
  esgMonth,
  onEsgMonth,
  onEsgRefresh,
  esgMetric,
  onEsgMetric,
}) {
  const [open, setOpen] = useState(false)
  const dataCount = LAYERS.filter(
    (l) => l.group === 'Data' && layers[l.key] && !disabledReason[l.key],
  ).length

  const loading = {
    parcels: Boolean(parcelsProgress),
    esg: status.esg.loading,
  }

  const details = {
    parcels: parcelsProgress ? (
      <div className="gm-layer-note">
        Memuat lahan {parcelsProgress.done}/{parcelsProgress.total}
      </div>
    ) : null,
    esg: (
      <>
        <Segment
          label="Tampilan ESG"
          options={ESG_MODES}
          value={layers.esgHotspot ? 'hotspot' : 'points'}
          onChange={(v) => onChange({ ...layers, esgHotspot: v === 'hotspot' })}
        />
        <Segment
          label="Skor ESG"
          options={ESG_METRICS}
          value={esgMetric}
          onChange={onEsgMetric}
        />
        <PMBMonthPicker
          label="Bulan"
          value={esgMonth}
          onChange={(v) => v && onEsgMonth(v)}
          testId="spatial-esg-month"
        />
        <CustomButton
          onClick={onEsgRefresh}
          size="sm"
          outline
          color="primary"
          className="d-flex align-items-center mt-2"
          disabled={status.esg.loading}
          testId="spatial-esg-refresh"
          title="Perbarui data ESG"
          aria-label="Perbarui data ESG"
        >
          <RefreshCw size={14} />
        </CustomButton>
        {status.esg.error || status.esg.needsPermission ? (
          <div className="gm-layer-note">
            {status.esg.error
              ? 'Gagal memuat data ESG.'
              : 'Butuh izin detail ESG. Minta akses di dashboard ESG.'}
          </div>
        ) : null}
      </>
    ),
  }

  return (
    <div className="gm-chip-wrap">
      <button
        type="button"
        className={`gm-chip ${dataCount ? 'gm-chip--active' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="menu"
        data-testid="spatial-layers-toggle"
      >
        <Layers size={16} />
        Lapisan{dataCount ? ` (${dataCount})` : ''}
        <ChevronUp size={14} />
      </button>
      {open ? (
        <>
          <div className="gm-menu-backdrop" onClick={() => setOpen(false)} />
          <div
            className="gm-menu gm-menu--up gm-menu--layers spatial-scrollbar"
            role="menu"
          >
            {['Dasar', 'Data'].map((group) => (
              <div key={group}>
                <div className="gm-menu-group">{group}</div>
                {group === 'Data' ? (
                  <div className="gm-menu-hint">
                    Hanya satu heatmap yang dapat aktif sekaligus.
                  </div>
                ) : null}
                {LAYERS.filter((l) => l.group === group).map((l) => {
                  const disabled = Boolean(disabledReason[l.key])
                  return (
                    <div key={l.key}>
                      <label
                        className={`gm-menu-item gm-menu-item--check ${
                          disabled ? 'gm-menu-item--disabled' : ''
                        }`}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input m-0"
                          checked={Boolean(layers[l.key]) && !disabled}
                          disabled={disabled}
                          onChange={() =>
                            onChange({ ...layers, [l.key]: !layers[l.key] })
                          }
                          data-testid={`spatial-layer-${l.key}`}
                        />
                        <span className="gm-menu-title">{l.label}</span>
                        {loading[l.key] && layers[l.key] && !disabled ? (
                          <Spinner size="sm" color="primary" className="ms-auto" />
                        ) : null}
                      </label>
                      {disabled ? (
                        <div className="gm-layer-detail gm-layer-note">
                          {disabledReason[l.key]}
                        </div>
                      ) : layers[l.key] && details[l.key] ? (
                        <div className="gm-layer-detail">{details[l.key]}</div>
                      ) : null}
                    </div>
                  )
                })}
              </div>
            ))}
          </div>
        </>
      ) : null}
    </div>
  )
}
